<template>
  <el-dialog
    title="添加课件目录"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >
    <div class="product-add pb50">
      <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
        <div class="common-form">添加课件目录</div>
        <el-form-item label="所属组织" prop="ma_organization_id">
          <el-select 
            v-model="form.ma_organization_id" 
            placeholder="请选择所属组织"
            style="width: 100%;"
            clearable
            filterable
          >
            <el-option
              v-for="dept in organizationList"
              :key="dept.ma_organization_id"
              :label="dept.name"
              :value="dept.ma_organization_id"
            />
          </el-select>
        </el-form-item>
        <!-- 所属行业：多选级联 -->
        <el-form-item label="所属行业" prop="industry_id">
          <el-cascader
            v-model="form.industry_id"
            :options="industryTree"
            :props="industryCascaderProps"
            placeholder="请选择所属行业（可多选）"
            style="width: 100%;"
            clearable
            filterable
            @change="handleCascaderChange('industry_id', $event)"
          ></el-cascader>
        </el-form-item>

        <!-- 培训类别：多选级联 -->
        <el-form-item label="培训类别" prop="class_id">
          <el-cascader
            v-model="form.class_id"
            :options="classTree"
            :props="classCascaderProps"
            placeholder="请选择培训类别（可多选）"
            style="width: 100%;"
            clearable
            filterable
            @change="handleCascaderChange('class_id', $event)"
          ></el-cascader>
        </el-form-item>

        <!-- 上级目录：单选级联 -->
        <el-form-item label="上级目录" prop="p_id">
          <el-cascader
            v-model="form.p_id"
            :options="directoryTree"
            :props="directoryCascaderProps"
            placeholder="请选择上级目录（顶级目录请留空）"
            style="width: 100%;"
            clearable
            filterable
          ></el-cascader>
        </el-form-item>

        <el-form-item label="课件目录名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入课件目录名称" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
        </el-form-item>

        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
          <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
        </div>
      </el-form>
      <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
    </div>
  </el-dialog>
</template>

<script>
import AfuncApi from '@/api/afunc.js';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';

export default {
  components: { 
    Upload, 
    Categoryas, 
    draggable, 
    Uediter 
  },
  data() {
    return {
      organizationList: [],
      isupload: false,
      isImg: false,
      ueditor: { text: '', config: { initialFrameWidth: 400, initialFrameHeight: 500 } },
      // 无限级树形数据
      industryTree: [],
      classTree: [],
      directoryTree: [],
      // 行业多选配置
      industryCascaderProps: {
        multiple: true, // 核心：启用多选模式
        checkStrictly: true, // 允许选任意层级
        expandTrigger: 'click',
        value: 'courseware_industry_id',
        label: 'name',
        children: 'children',
        emitPath: true, // 必须返回完整路径
        collapseTags: false, // 不折叠标签
        clearable: true
      },
      // 类别多选配置
      classCascaderProps: {
        multiple: true, // 核心：启用多选模式
        checkStrictly: true,
        expandTrigger: 'click',
        value: 'courseware_class_id',
        label: 'name',
        children: 'children',
        emitPath: true,
        collapseTags: false,
        clearable: true
      },
      // 上级目录单选配置
      directoryCascaderProps: {
        checkStrictly: true,
        expandTrigger: 'click',
        value: 'courseware_directory_id',
        label: 'name',
        children: 'children',
        clearable: true
      },
      form: {
        name: '',
        sort: 50,
        industry_id: [], // 多选值：二维数组，如 [[1], [2,3], [4,5,6]]
        class_id: [],    // 多选值：二维数组
        p_id: [],         // 单选值：一维数组，如 [1] 或 [1,2]
        ma_organization_id:''
      },
      loading: false,
      // 表单验证
      rules: {
        name: [{ required: true, message: '请输入课件目录名称', trigger: 'blur' }],
        ma_organization_id: [{ required: true, message: '请选择所属组织', trigger: 'blur' }],
        industry_id: [{ 
          required: true, 
          message: '请选择所属行业', 
          trigger: 'change', 
          type: 'array',
          validator: (rule, value, callback) => {
            if (!value || value.length === 0) {
              callback(new Error('请选择所属行业'));
            } else {
              callback();
            }
          }
        }],
        class_id: [{ 
          required: true, 
          message: '请选择培训类别', 
          trigger: 'change', 
          type: 'array',
          validator: (rule, value, callback) => {
            if (!value || value.length === 0) {
              callback(new Error('请选择培训类别'));
            } else {
              callback();
            }
          }
        }]
      },
      dialogVisible: false,
      iscategorya: false,
      excludeIds: [],
      isProductUpload: false,
      code: "album"
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    // 初始化加载树形数据
    this.getTree('courseware_industry');
    this.getTree('courseware_class');
    this.getTree('courseware_directory');
    this.loadOrganization();
  },
  props: {
    open_add: {
      type: Boolean,
      default: false
    },
    p_id: {
      type: [Array, Number],
      default: function() {
        return [];
      }
    }
  },
  methods: {
    async loadOrganization() {
      try {
        const response = await AfuncApi.call({
          model: 'ma_organization',
          action: 'index',
        });
        
        // 关键修复：增加空值判断
        if (!response) {
          this.$message.warning('组织列表接口返回为空');
          this.organizationList = [];
          return;
        }
        
        if (response.code === 1 && response.data.list) { // 修复：可选链操作符防止data为null
          this.organizationList = response.data.list || [];
        } else {
          this.$message.warning('获取组织列表失败：' + (response.msg || '未知错误'));
          this.organizationList = [];
        }
      } catch (error) {
        console.error('加载组织列表失败:', error);
        this.$message.error('加载组织列表失败，请稍后重试');
        this.organizationList = []; // 确保数组有初始值
      }
    },
    // 加载无限级树形数据
    getTree: async function(table) {
      try {
        var response = await AfuncApi.call({
          model: 'courseware_directory',
          action: 'getInfiniteTree',
          type: table,
        });
        if (response.code === 1) {
          if (table === 'courseware_industry') {
            this.industryTree = response.data.list || [];
          } else if (table === 'courseware_class') {
            this.classTree = response.data.list || [];
          } else if (table === 'courseware_directory') {
            this.directoryTree = response.data.list || [];
          }
        } else {
          this.$message.error(response.msg || '加载数据失败');
        }
      } catch (error) {
        console.error('加载' + table + '树形数据失败:', error);
        this.$message.error('加载分类数据失败，请稍后重试');
      }
    },
    
    // 核心：父子互斥逻辑 - 移除子节点保留父节点
    handleCascaderChange: function(field, selectedArr) {
      // 空值处理
      if (!Array.isArray(selectedArr) || selectedArr.length === 0) {
        this.$set(this.form, field, []);
        return;
      }
      
      // 深拷贝避免修改原数据
      var selectCopy = JSON.parse(JSON.stringify(selectedArr));
      var finalSelect = [];
      
      // 按路径长度排序，短的在前（父节点在前）
      selectCopy.sort((a, b) => a.length - b.length);
      
      // 遍历所有选择项
      for (var i = 0; i < selectCopy.length; i++) {
        var currentPath = selectCopy[i];
        var isChild = false;
        
        // 检查当前路径是否是已选中的某个路径的子路径
        for (var j = 0; j < finalSelect.length; j++) {
          var existingPath = finalSelect[j];
          
          // 如果当前路径是已选中路径的子路径（现有路径是当前路径的前缀）
          if (currentPath.length > existingPath.length) {
            // 检查前缀是否匹配
            var isPrefix = true;
            for (var k = 0; k < existingPath.length; k++) {
              if (currentPath[k] !== existingPath[k]) {
                isPrefix = false;
                break;
              }
            }
            if (isPrefix) {
              isChild = true;
              break;
            }
          }
        }
        
        // 如果不是任何已选中路径的子节点，则添加
        if (!isChild) {
          finalSelect.push(currentPath);
        }
      }
      
      // 响应式更新表单数据
      this.$set(this.form, field, finalSelect);
    },
    
    chooseCategory: function() {
      this.iscategorya = true;
    },
    
    openUpload: function(e) {
      this.isupload = true;
    },
    
    dialogFormVisible: function(result) {
      this.$emit('close', { openDialog: false, type: '' });
    },
    
    cancelFunc: function() {
      this.dialogFormVisible('error');
    },
    
    // 提交表单
    onSubmit: async function() {
      try {
        // 表单验证
        await this.$refs.form.validate();
      } catch (err) {
        console.log('表单验证失败:', err);
        return;
      }
      
      this.loading = true;

      // 处理多选值：二维数组 → 逗号分隔字符串（取最后一级ID）
      var handleMultiple = function(arr) {
        if (!Array.isArray(arr) || arr.length === 0) return '';
        var ids = [];
        for (var i = 0; i < arr.length; i++) {
          if (Array.isArray(arr[i]) && arr[i].length > 0) {
            ids.push(arr[i][arr[i].length - 1]);
          }
        }
        return ids.join(',');
      };
      
      // 处理单选值：一维数组 → 最后一级ID
      var handleSingle = function(arr) {
        if (!Array.isArray(arr) || arr.length === 0) return 0;
        return arr[arr.length - 1];
      };

      // 构造提交数据
      var formData = {
        name: this.form.name,
        sort: this.form.sort,
        courseware_industry_id: handleMultiple(this.form.industry_id),
        courseware_class_id: handleMultiple(this.form.class_id),
        ma_organization_id:this.form.ma_organization_id,
        p_id: handleSingle(this.form.p_id)
      };

      try {
        var response = await AfuncApi.call({
          model: 'courseware_directory',
          action: 'add',
          ...formData,
        });
        
        if (response.code === 1) {
          this.$message.success(response.msg || '添加目录成功');
          this.dialogFormVisible('success');
          // 清空表单
          this.$refs.form.resetFields();
          this.form.sort = 50;
        } else {
          this.$message.error(response.msg || '添加目录失败');
        }
      } catch (error) {
        console.error('添加目录失败:', error);
        this.$message.error('添加目录失败，请稍后重试');
      } finally {
        this.loading = false;
      }
    },
    
    openProductUpload: function(code) {
      this.isProductUpload = true;
      this.code = code;
    },
    
    // 图片上传处理
    returnProductImgsFunc: function(e) {
      if (!e || e.length === 0) return;
      
      var imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
      var isLegal = true;

      for (var i = 0; i < e.length; i++) {
        var element = e[i];
        var filePath = element.file_path || '';
        var ext = filePath.split(".").pop() || '';
        if (imgExpt.indexOf(ext.toLowerCase()) === -1) {
          isLegal = false;
          break;
        }
      }
      
      if (!isLegal) {
        this.$message.error("图片类型有误，请选择bmp/jpg/jpeg/png/gif格式");
        return;
      }
      
      // 响应式赋值图片
      if (this.code === 'album') {
        var newAlbum = this.form.image ? this.form.image.concat(e) : e;
        this.$set(this.form, "image", newAlbum);
      } else {
        var newBannar = this.form.bannar ? this.form.bannar.concat(e) : e;
        this.$set(this.form, "bannar", newBannar);
      }
      this.isProductUpload = false;
    },
    
    // 删除图片
    deleteImg: function(index, code) {
      if (code === 'album' && this.form.image) {
        this.form.image.splice(index, 1);
      } else if (code === 'bannar' && this.form.bannar) {
        this.form.bannar.splice(index, 1);
      }
    }
  }
};
</script>

<style scoped>
/* 基础样式 */
.common-form {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
}
.max-w460 {
  max-width: 460px;
  width: 100%;
}
.common-button-wrapper {
  margin-top: 20px;
  text-align: center;
}
.pb50 {
  padding-bottom: 50px;
}
</style>

<style>
/* 多选级联组件样式优化 */
.el-cascader__tags {
  flex-wrap: wrap !important;
  white-space: normal !important;
  min-height: 32px;
  line-height: normal;
}

.el-cascader__tag {
  margin: 2px 4px 2px 0 !important;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.el-cascader__input {
  min-height: 32px !important;
  line-height: 32px !important;
  padding: 0 12px !important;
}

.el-cascader__search-input {
  min-height: 30px !important;
}

/* 确保级联下拉框在多选模式下正常显示 */
.el-cascader__dropdown {
  max-height: 400px !important;
  overflow-y: auto !important;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/courseware_directory/index/part/add.vue